import React, { useState, useEffect } from 'react';

import { languageController } from '../../../../controllers/language/languageController'
import formLang from '../../../../controllers/language/shared/form'

import Input from '../../../1_Atoms/Forms/Input/Input'
import Textarea from '../../../1_Atoms/Forms/Textarea/Textarea';
import Select from '../../../1_Atoms/Forms/Select/Select'
import { useForm } from '../../../../hooks/useForm'
import Button from '../../../1_Atoms/Button/Button'
import { Svg } from '../../../1_Atoms/Svg/Svg'
import Form from '../../../2_Molecules/Form/Form'
import FormGroup from '../../../2_Molecules/FormGroup/FormGroup'

interface UserInformation {
  firstname: string
  lastname: string
  email: string
  phone: string
  preferredContact: string
  message: string
  purchaseDate: string
  [key: string]: string | number | boolean
}

interface YourInformationStepProps {
  language: string
  handleNextStep: (data: { userInformation: UserInformation }) => void
}

interface SelectOption {
  [key: string]: string
}

interface Validations {
  [key: string]: string[]
}

const YourInformationStep: React.FC<YourInformationStepProps> = ({
  language,
  handleNextStep,
}) => {
  const purchaseDateOptions: SelectOption[] = formLang.select.expectedPurchaseOptions;

  const initState: UserInformation = {
    firstname: '',
    lastname: '',
    email: '',
    phone:'',
    preferredContact:'Email',
    message:'',
    purchaseDate: purchaseDateOptions[0][language]
  }

  const [phoneValue, setPhoneValue] = useState<string>('')
  const [validations, setValidations] = useState<Record<string, Array<'required' | 'name' | 'nameMaxMin' | 'postalcode' | 'email' | 'phone' | 'isAlphaNumeric' | 'vin' | 'odometer' | 'positive'>>>({
    firstname: ['required', 'name', 'nameMaxMin'],
    lastname: ['required', 'name', 'nameMaxMin'],
    email: ['required', 'email'],
    phone:['phone'],
    purchaseDate: ['required'],
  })

  const { handleSubmit, handleChange, data, errors } = useForm({
    initState,
    validations,
    onSubmit: () => {
      handleNextStep({ userInformation: data as unknown as UserInformation })
    },
  })

  const { firstname, lastname, email, purchaseDate, phone, preferredContact, message } = data;

  const firstnameStr = String(firstname);
  const lastnameStr = String(lastname);
  const emailStr = String(email);
  const messageStr = String(message);
  const purchaseDateStr = String(purchaseDate);

  useEffect(() => {
    setValidations(prevValidations => {
      const newValidations = { ...prevValidations }; // Create a new object copy
      if (phoneValue.length > 9) {
        // Add 'required' rule to preferredContact
        newValidations.preferredContact = ['required'];
      } else {
        // Remove preferredContact rule
        if (newValidations.preferredContact) {
          delete newValidations.preferredContact;
        }
      }
      return newValidations;
    });
  }, [phoneValue])

  return (
    <div className="mz-your-information-step-tie">
      <div className="mz-container">
        <div className="grid-inner-content">
          <h5 className="mz-your-information-step-tie__title">{languageController.getCopy('tradeInEstimator', 'step3Title')}</h5>
          <Form
            onSubmit={handleSubmit}
            isDark={false}
            noValidate={true}
            requiredFieldsHelperText={true}
          >
            <FormGroup md={2}>
              <Input
                type="text"
                name="firstname"
                label={languageController.getFormCopy('label', 'firstname')}
                value={firstnameStr}
                isRequired={true}
                errorMessage={errors.firstname}
                onChange={handleChange}
                maxLength={50}
              />
              <Input
                type="text"
                name="lastname"
                label={languageController.getFormCopy('label', 'lastname')}
                value={lastnameStr}
                isRequired={true}
                errorMessage={errors.lastname}
                onChange={handleChange}
                maxLength={50}
              />
            </FormGroup>
            <Input
              type="email"
              name="email"
              label={languageController.getFormCopy('label', 'email')}
              value={emailStr}
              isRequired={true}
              errorMessage={errors.email}
              onChange={handleChange}
              maxLength={500}
            />
            {/*<FormGroup md={2}>
              <Input
                  type="text"
                  name="phone"
                  label={languageController.getFormCopy('label', 'phone')}
                  id="contact-phone"
                  value={phone}
                  isRequired={false}
                  errorMessage={errors.phone}
                  onChange={(e)=>{
                    handleChange(e)
                    if(phoneValue != e.target.value)setPhoneValue(e.target.value.replace(/\D/g, ''))
                  }}
                  maxLength={14}
                />*/}
              
                {/*phoneValue.length > 9 &&
                  
                    <Select
                      name="preferredContact"
                      label={languageController.getFormCopy('label', 'preferredContact')}
                      id="contact-preferredContact"
                      value={preferredContact}
                      isRequired={true}
                      errorMessage={errors.preferredContact}
                      onChange={handleChange}
                      placeholder={languageController.getFormCopy('placeholder', 'preferredContact')}
                      options={formLang.select.preferredContact.map(subject => ({
                        value: subject[language],
                        label: subject[language],
                      }))}
                    />
                  
                  }
              </FormGroup>*/}
                <Textarea
                    name="message"
                    label={languageController.getFormCopy('label', 'message')}
                    id="contact-message"
                    value={messageStr}
                    isRequired={false}
                    errorMessage={errors.message}
                    onChange={handleChange}
                    maxLength={1999}
                    rows={5}
                  />
            <Select
              name="purchaseDate"
              label={languageController.getFormCopy('label', 'expectedPurchaseDate')}
              value={purchaseDateStr}
              isRequired={true}
              errorMessage={errors.purchaseDate}
              onChange={handleChange}
              options={purchaseDateOptions.map(option => ({
                value: option[language],
                label: option[language],
              }))}
            />
            <Button
              type="submit"
              className="mz-btn--primary mz-btn--red"
              label={languageController.getCopy('global', 'continue')}
              buttonIcon={<Svg type="chevron_small" size={0.8} colour="white" style={{ top: '1px' }} />}
              buttonIconPosition="right"
              disabled={(!firstname || !lastname || !email)}
            />
          </Form>
        </div>
      </div>
    </div>
  )
}

export default YourInformationStep
